import { createGlobalStyle } from "styled-components";
import cssVariablesSummary from "./undraw_generated/cssVariablesSummary";

const mappedColors = {
  "#6c63ff": "var(--primary-500)",
  "#f2f2f2": "var(--surface-100)",
  "#3f3d56": "var(--primary-200-relative)",
};

export const UndrawCssVariablesProvider = createGlobalStyle`
  :root {
    ${Object.entries(cssVariablesSummary)
      .map(([key, value]) => {
        const originalColor = "#" + key;

        const mappedColor = mappedColors[originalColor];

        if (mappedColor) {
          return `
            --undraw-color-${key}: ${mappedColor};
          `;
        }

        return `
          --undraw-color-${key}:  ${originalColor};
        `;
      })
      .join("")} 
  }
`;
